import styled from 'styled-components';

import { H6 } from 'components/Typography';

import { colorBlack900, colorGrayLight } from 'styles';

export const SubTitle = styled(H6)`
  line-height: 24px;
`;

export const Text = styled.p`
  font-size: 14px;
  line-height: 24px;
  color: ${colorBlack900};
`;

export const Line = styled.hr`
  border: 0;
  border-bottom: 1px solid ${colorGrayLight};
  margin: 32px 0 24px;
`;
